import * as React from 'react';

import { NBSP } from '../../constants';
import { trackOpenRailwayLink } from '../../tracking';
import styles from '../village_info/VillageInfo.css';

interface IProps {
  stationName: string;
  link: string;
  distanceText: string;
}

export const StationItem = (props: IProps) => {
  const { stationName, link, distanceText } = props;

  return (
    <div className={styles['railway']}>
      <a className={styles['address-link']} href={link} onClick={trackOpenRailwayLink} target="_blank">
        <span>{stationName}</span>
      </a>
      {distanceText && (
        <>
          ,{NBSP}
          <span className={styles['distance']}>{distanceText}</span>
        </>
      )}
    </div>
  );
};
